export default {"src":"/_next/static/media/squid.4bc42684.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};